/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleLeftIcon16Light = forwardRef('ArrowFigureACircleLeftIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11 7.5a.5.5 0 0 0-.5-.5H5.381l1.94-1.616a.5.5 0 1 0-.641-.768L4.602 6.348a1.5 1.5 0 0 0 0 2.304l2.078 1.732a.5.5 0 0 0 .64-.768L5.381 8H10.5a.5.5 0 0 0 .5-.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 7.5a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0ZM7.5 2a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Z" })));
});
